export const getError = state => state.addProject.get('error')
export const getIsSubmitting = state => state.addProject.get('isSubmitting')
